export default "__VITE_ASSET__CEc2S$E9__"